module.exports = __webpack_public_path__ + "static/the-peak-rera_page-0002-7a7fb029347fdd1bcb7b6b5bb33ccc61.jpg";